import { cipo } from 'cipo';
    
cipo.controller('susersController', 
function ($scope, $state) {
    
});
